import { PublicReplay } from '../api/public';
import { OlympusScreen } from './OlympusScreen';
import { DogHouseScreen } from './DogHouseScreen';
import { SlotsScreen } from './SlotsScreen';
import { CrashReplay } from './CrashReplay';
import { Icon } from '../components/Icon';

// Просмотр чужого реплея, открытого по ссылке t.me/<bot>?startapp=replay_<id>.
export function SharedReplay({ replay, onClose }: { replay: PublicReplay; onClose: () => void }) {
  if (replay.game === 'crash' && replay.crash)
    return (
      <CrashReplay
        betId={replay.betId}
        name={replay.name}
        crashPoint={replay.crash.crashPoint}
        cashMultiplier={replay.crash.cashMultiplier}
        totalWin={replay.totalWin}
        onBack={onClose}
      />
    );
  if (replay.game === 'olympus')
    return <OlympusScreen onBack={onClose} replay={replay.play} shareId={replay.betId} />;
  if (replay.game === 'doghouse')
    return <DogHouseScreen onBack={onClose} replay={replay.play} shareId={replay.betId} />;
  return (
    <>
      <div className="page-head">
        <button className="icon-btn" onClick={onClose} title="Назад">
          <Icon name="back" size={18} />
        </button>
        <span className="title">Реплей {replay.name}</span>
      </div>
      <SlotsScreen
        replay={{ base: replay.play.base, free: replay.play.free, totalWin: replay.play.totalWin }}
        shareId={replay.betId}
      />
    </>
  );
}
